export enum AnalyticsEventActions {
    FromMainPage = 'fromMainPage',
    FromHeader = 'fromHeader',
    FromFAQ = 'fromFAQ',
    Login = 'user authenticated',
    Logout = 'user logged out',
    Join = 'join'
}
